import React, { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import s from './CountDown.scss';

const CountDown = ({ content }) => {
	const pad = (num, size) => `0${num}`.substr(`0${num}`.length - size);

	// fixes "Date.parse(date)" on safari
	const parseDate = (date) => {
		const parsed = Date.parse(date);
		if (!Number.isNaN(parsed)) return parsed;
		return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
	};

	const getTimeRemaining = (endtime) => {
		const total = parseDate(endtime) - Date.parse(new Date());
		return {
			total,
			days: Math.floor(total / (1000 * 60 * 60 * 24)),
			hours: Math.floor((total / (1000 * 60 * 60)) % 24),
			minutes: Math.floor((total / 1000 / 60) % 60),
			// seconds: Math.floor((total / 1000) % 60),
		};
	};

	const startTime = getTimeRemaining(content);
	const [days, updateDays] = useState(pad(startTime.days, 2));
	const [hours, updateHours] = useState(pad(startTime.hours, 2));
	const [minutes, updateMinutes] = useState(pad(startTime.minutes, 2));
	// const [seconds, updateSeconds] = useState(pad(startTime.seconds, 2));
	let timeinterval;

	useEffect(() => {
		timeinterval = setInterval(() => {
			const time = getTimeRemaining(content);

			if (time.total <= 0) {
				clearInterval(timeinterval);
			} else {
				updateDays(pad(time.days, 2));
				updateHours(pad(time.hours, 2));
				updateMinutes(pad(time.minutes, 2));
				// updateSeconds(pad(time.seconds, 2));
			}
		}, 1000);

		return () => {
			clearInterval(timeinterval);
		};
	});

	return (
		<div className={s.countDown}>
			<div className={s.countDown_item}>
				<div className={s.countDown_item_number}>{ days }</div>
				<div className={s.countDown_item_label}>Days</div>
			</div>
			<div className={[s.countDown_item, s.countDown_item__dot].join(' ')}>
				<div className={s.countDown_item_dot}>.</div>
			</div>
			<div className={s.countDown_item}>
				<div className={s.countDown_item_number}>{ hours }</div>
				<div className={s.countDown_item_label}>Hours</div>
			</div>
			<div className={[s.countDown_item, s.countDown_item__dot].join(' ')}>
				<div className={s.countDown_item_dot}>.</div>
			</div>
			<div className={s.countDown_item}>
				<div className={s.countDown_item_number}>{ minutes }</div>
				<div className={s.countDown_item_label}>Minutes</div>
			</div>
		</div>
	);
};

export default hot(module)(CountDown);
